// require("dotenv").config({
//   path: `.env.${process.env.NODE_ENV}`,
// })
import sanityClient from "@sanity/client"

const client = sanityClient({
  projectId: "elrteb68",
  dataset: "production",
  useCdn: true, // `false` if you want to ensure fresh data
})

export default client
